import { Link } from "react-router-dom";

export default function ArticleCard({ article, variant = "default" }) {
  const Wrap = article.is_stub ? "div" : Link;
  const wrapProps = article.is_stub
    ? { "aria-disabled": "true" }
    : { to: `/articles/${article.slug}` };

  if (variant === "feature") {
    return (
      <Wrap
        {...wrapProps}
        className="group grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center"
        data-testid={`article-feature-${article.slug}`}
      >
        <div className="relative overflow-hidden rounded-3xl aspect-[4/3] bg-sand-200 shadow-soft transition-all duration-500 ease-out group-hover:shadow-card group-hover:-translate-y-1">
          <img
            src={article.hero_image}
            alt={article.title}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
          />
        </div>
        <div>
          <div className="overline mb-4">{article.category}</div>
          <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-forest-900 mb-5">
            {article.title}
          </h3>
          <p className="text-forest-700 leading-relaxed text-lg mb-6">
            {article.excerpt}
          </p>
          <span className="link-underline text-sm">
            {article.is_stub ? "Coming soon" : "Read article →"}
          </span>
        </div>
      </Wrap>
    );
  }

  return (
    <Wrap
      {...wrapProps}
      className={`group block ${article.is_stub ? "opacity-80" : ""}`}
      data-testid={`article-card-${article.slug}`}
    >
      <div className="relative overflow-hidden rounded-2xl aspect-[5/4] bg-sand-200 mb-5 shadow-soft transition-all duration-500 ease-out group-hover:shadow-card group-hover:-translate-y-1">
        <img
          src={article.hero_image}
          alt={article.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
        />
        {article.is_stub && (
          <span className="absolute top-4 left-4 text-[10px] font-semibold tracking-[0.22em] uppercase text-sage-700 bg-sand-50 px-3 py-1 rounded-full border border-sand-300">
            Coming Soon
          </span>
        )}
      </div>
      <div className="overline mb-2">{article.category}</div>
      <h3 className="font-serif text-2xl text-forest-900 leading-tight tracking-tight mb-2">
        {article.title}
      </h3>
      <p className="text-forest-700 text-[15px] leading-relaxed mb-3">
        {article.excerpt}
      </p>
      <span className="text-xs uppercase tracking-[0.22em] text-sage-600">
        {article.is_stub ? "Coming soon" : article.read_time}
      </span>
    </Wrap>
  );
}
